import React, { useEffect, useState } from "react";

import "./jobListingSearchResultCards.scss";
import { useNavigate } from "react-router-dom";
import { Modal, Button,Drawer } from "antd";
import NuJobsViewJob from "../../../components/nujobs/nujobsViewJob";
import logo from "../../../assets/landingFeatures/explorer.png";
import logoCropped from "../../../assets/landingFeatures/explorer_cropped.png";
import useNuJobsStore from "../../../store/nujobs.store";
import { EyeOutlined, HeartFilled, HeartOutlined } from "@ant-design/icons";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";
import { NUJOBS_URL } from "../../../helper/axioscontants";

export default function JobListingSearchResultCards({alreadyApplied, 
                                                     openJd, idx,
                                                     loggedIn,applyNowCallBackLoggedIn,
                                                    currentPage,source}) {

  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedJD, setSelectedJD] = useState(openJd);
  const [appliedJobs, setAppliedJobs] = useState([]);
  const { setApplyNowPopRouting,resetApplyNowPopRouting,toggleMetaDataFav,setMetaDataViewed,searchMetaData,setMetaDataApplied } = useNuJobsStore();
  const { myResumes,profileCompleted } = useNuJobDetailsStore();

  const nujUserDetails = JSON.parse(localStorage.getItem("nujobsUserDetails"));
  const [jdMetaData, setJdMetaData] = useState(searchMetaData?.[idx]);
  useEffect(() => {
     setJdMetaData(searchMetaData?.[idx])
  }, [searchMetaData]);

  function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
  }   
    
  const getCompanyLogoSrc = (rawLogo) => {
    if (!rawLogo) return null;
    if (rawLogo.startsWith("data:image")) return rawLogo;
    return `data:image/png;base64,${rawLogo}`;
  };

  const companyLogoSrc =
    getCompanyLogoSrc(
      openJd?.companylogo ||
        openJd?.CompanyLogo ||
        openJd?.JDClient?.CompanyLogo,
    ) || logo;
  const isCustomerProject = openJd?.JDProject?.ReqType === "customer_project";
  const isFTE = openJd?.JDClient?.ClientJobType === "FTE";

  const handleNavigation = () => {

    var jdInfo = {
      qhoid:openJd?.QhOID,
      qhcompanyjid: openJd?.QhCompanyJID
    }
    //store the Applynow event
    console.log("Storing the popup info", jdInfo)
    setApplyNowPopRouting(jdInfo)

    navigate("/nujobsotpprocess", {
      state: {
        reason: "start",
        trigger: "signin",
      },
    });
  };

    const applyNowCallBackLoggedInWithResumeCheck = async () => {
        if(myResumes?.filter((item) => item.resumestatus != "NO_RES")?.length > 0 && profileCompleted > 0){
          if (applyNowCallBackLoggedIn) {
            try {
              await applyNowCallBackLoggedIn(openJd);
              setAppliedJobs([...appliedJobs, openJd]);
            } catch (e) {
              console.log(e);
            }
            setMetaDataApplied(idx)
            addPendingSync(
                "applied",
                openJd.QhOID,
                openJd.QhCompanyJID
              );            
          }
        }else{
            // Trigger the Modal only if NOT logged in
            Modal.confirm({
                title: "Missing Resume/ Incomplete Profile",
                content:
                "Resume is not uploaded or Profile is not complete.",
                okText: "Sign In",
                cancelButtonProps: { style: { display: "none" } },
                centered: true,
                closable: true,
                maskClosable: true,
                onCancel: () => {
                console.log("Modal closed or cancelled");
                },        
                footer: (
                <div
                    style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    paddingBottom: "10px",
                    marginTop: "20px",
                    }}
                >
                    <Button
                    style={{
                        fontFamily: 'Segoe UI',               
                        color: "#7c8cce",
                        padding: "8px 14px",
                        borderRadius: "8px",
                        border: "10px",
                        border: "1px solid #96a5e2",
                        fontSize: "12px",
                        fontWeight: 600,
                        cursor: "pointer",
                        transition: "0.2s ease",
                        backgroundColor:"#fff"
                    }}
                    onClick={() => {
                        Modal.destroyAll(); // Close the modal manually
                    }}
                    >
                    OK
                    </Button>
                </div>
                ),
            });            
        }

    };

  const handleClickApply = async () => {
    if (loggedIn) {
          applyNowCallBackLoggedInWithResumeCheck()
    } else {
      // Trigger the Modal only if NOT logged in
      Modal.confirm({
        title: "Apply Now",
        content:
          "Sign In to apply for this Role.",
        okText: "Sign In",
        cancelButtonProps: { style: { display: "none" } },
        centered: true,
        closable: true,
        maskClosable: true,
        onCancel: () => {
          console.log("Modal closed or cancelled");
          resetApplyNowPopRouting()
        },        
        footer: (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              paddingBottom: "10px",
              marginTop: "20px",
            }}
          >
            <Button
              style={{
                  fontFamily: 'Segoe UI',               
                  color: "#7c8cce",
                  padding: "8px 14px",
                  borderRadius: "8px",
                  border: "10px",
                  border: "1px solid #96a5e2",
                  fontSize: "12px",
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "0.2s ease",
                  backgroundColor:"#fff"
              }}
              onClick={() => {
                Modal.destroyAll(); // Close the modal manually
                handleNavigation();
              }}
            >
              Sign In
            </Button>
          </div>
        ),
      });
    }
  };

  const handleClickJD = () => { 
      //window.open(`/nujobshome/nujobsViewJob/${openJd?.QhCompanyJID}`,"_blank
        setSelectedJD(openJd);
        setOpenDrawer(true);
  };
  const jdHandler = (jobID) => {
    if((source =="opensearch") && (loggedIn == false)){
      navigate(`/nujobsViewJobsContainerOpenSearch/${source}/${jobID}`);
    }else{
      if(loggedIn){ 
        addPendingSync("viewed",openJd.QhOID,openJd.QhCompanyJID);              
        navigate(`/nujobshome/nujobsViewJobsContainer/${source}/${jobID}`);
      }
    }   
  };
  const linkHandler = (idx) => {
       // navigate(`/job/${openJd?.QhOID}/${openJd?.QhCompanyJID}`);
    const url = `${NUJOBS_URL}/job/${openJd?.QhOID}/${openJd?.QhCompanyJID}`;
    window.open(url, "_blank", "noopener,noreferrer");       
  };

  const MAX_PENDING_SYNC = 10;
  const addPendingSync= (action, qhoid, qhcompanyjid) => {
      const key = "NuJobsPendingSync";

      //action tobe unfavorite or favorite or viewed
      if(jdMetaData?.isFavorite) action= "unfavorite"

      let pending = [];

      try {
          pending = JSON.parse(localStorage.getItem(key) || "[]");
      } catch {
          pending = [];
      }
      //console.log("Adding pending sync:", action, qhoid, qhcompanyjid, pending,openJd); 
      const timestamp = Math.floor(Date.now() / 1000);

      // Remove existing entry with same action + job
      pending = pending.filter(
          item =>
              !(
                  item.action === action &&
                  item.qhoid === qhoid &&
                  item.qhcompanyjid === qhcompanyjid
              )
      );

      // Add latest entry to front
      pending.unshift({
          action,
          qhoid,
          qhcompanyjid,
          timestamp,
      });

      // Keep only latest 10
      if (pending.length > MAX_PENDING_SYNC) {
          pending = pending.slice(0, MAX_PENDING_SYNC);
      }
      //console.log("Pending Sync Updated:", pending);

      localStorage.setItem(key, JSON.stringify(pending));
      if((action === "favorite")||(action === "unfavorite")){
          toggleMetaDataFav(idx, jdMetaData?.isFavorite ? false : true)
      }    
  }
  const getPostedDate = (postedOn) => {
    if (!postedOn) return "";

    const [day, month, year] = postedOn.split("-").map(Number);

    const postedDate = new Date(year, month - 1, day);
    const today = new Date();

    postedDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diffDays = Math.floor(
      (today - postedDate) / (1000 * 60 * 60 * 24)
    );

    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "1 day ago";

    return `${diffDays} days ago`;
  };
  return (
    <div className="nujob-card">
      
      <div className="job-card-title">
        <div className="job-card-logo-container">
            <img
              className="job-card-logo"
              src={companyLogoSrc}
              alt={`${openJd?.CompanyName || "Company"} logo`}
            />
        </div>        
        <div className="job-card-title-info">
          <div className="title-heading" onClick={()=>jdHandler(openJd?.QhCompanyJID)}>
            <span className="title-heading-job">
              {openJd?.JDDetails?.Title}{" "}
            </span>
            <span className="title-heading-jdid">
              {" "}
              [{openJd?.QhCompanyJID}]{" "}
            </span>
          </div>
            <div className = "title-postedDate">
              {getPostedDate(openJd?.JDOther?.PostingDate)}
            </div>    
        </div>
      </div>
                  {/* QUICK INFO ROW */}                 
                  <div className="job-card-tags">
                    <span>                      {
                        isCustomerProject?
                        <>
                          {isFTE?<>Client Not Disclosed</>:<>{openJd?.CompanyName}</>}
                        </>
                        :<>
                          {openJd?.CompanyName}
                        </>
                     }</span>                     
                    <span> {
                        isCustomerProject?
                        <>                          
                          {isFTE?<>{openJd?.JDClient?.ClientType}</>:<>{openJd?.AccountType}</>}
                        </>
                        :<>
                          {openJd?.AccountType}
                        </>
                     }</span>                      
                    <span> {openJd?.JDDetails?.JobTime} </span>
                    <span> {openJd?.JDDetails?.JobType} </span>
                    <span> {openJd?.JDRequired?.WorkMode} </span>
                    <span> {openJd?.JDRequired?.WorkLocation + " / " + openJd?.JDRequired?.Country}</span>                  
                  </div>                  
                  <div className="job-card-details">
                     <div className="job-card-details-size-sub-heading">
                       Details:
                     </div>
                     <div className="job-card-details-size"
                          style ={{borderRight: "2px solid"}}>
                       {openJd?.JDRequired?.MinExperience} to {openJd?.JDRequired?.MaxExperience} Yrs
                     </div>
                     <div className="job-card-details-size"
                           style ={{borderRight: "2px solid"}}>
                        As Per Market Standard
                     </div> 
                     <div className="job-card-details-size">
                        {openJd?.JDRequired?.NoticePeriod < 15? "Immediate Joiners": "Max Notice Period :" + openJd?.JDRequired?.NoticePeriod + " days"} 
                     </div>                                                                                                                                                                                        
                  </div>

 
                  <div className="job-card-details" onClick={handleClickJD} style = {{cursor: "pointer"}}>
                     <div className="job-card-details-size-sub-heading" >
                       Summary:
                     </div>
                     <div className="job-card-details-keywords" >
                       {"View Job Details"}
                     </div>                                                                                                                           
                  </div> 
                  <div className="job-card-details" onClick={handleClickJD} style = {{cursor: "pointer"}}>
                     <div className="job-card-details-size-sub-heading">
                       Key Skills:
                     </div>
                     <div className="job-card-details-keywords" >
                       {"View Job Details"}
                     </div>                                                                                                                           
                  </div>                   
                  <div className="job-card-details">
                     <div className="job-card-details-size-sub-heading">
                       Posted By:
                     </div>                 
                     <div className="job-card-details-keywords">
                       {openJd?.CompanyName}
                     </div>                                                                                                                           
                  </div> 

      <div className="job-card-details-end">
        <div className="job-card-details">
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "10px",            
            marginBottom: "10px",
            marginRight: "10px",
          }}
        >
            <button
                style={{
                  color: "#5171ed",
                  padding: "8px 14px",
                  borderRadius: "8px",
                  border: "none",
                  fontSize: "12px",
                  fontWeight: 600,
                  transition: "0.2s ease",
                }}
                onClick={linkHandler}
              >
                View Link
          </button>
           
          {loggedIn?
            <>
               {jdMetaData?.isViewed?
               <>
                  <button
                      style={{
                          width: "36px",
                          height: "36px",
                          borderRadius: "50%",
                          border: "1px solid #d9d9d9",
                          background: "#fff",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                      }}
                  >
                      <EyeOutlined style={{ color: jdMetaData?.isViewed ? "#1677ff" : "#999" }} />
                  </button>
               </>
               :<> </>
              }

                <button
                    style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        border: "1px solid #d9d9d9",
                        background: "#fff",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={() => {
                            addPendingSync(
                                "favorite",
                                openJd.QhOID,
                                openJd.QhCompanyJID
                            );
                    }}
                >
                    <HeartFilled style={{ color: jdMetaData?.isFavorite ? "#ff4d4f" : "#999" }} />
                </button>
            </>
            :<></>
          }
          {loggedIn &&  jdMetaData?.isApplied  ? (
            <>
              <button
                style={{
                  backgroundColor: "#cadbf0",
                  color: "#5171ed",
                  padding: "8px 14px",
                  borderRadius: "8px",
                  border: "none",
                  fontSize: "12px",
                  fontWeight: 600,
                  transition: "0.2s ease",
                }}
              >
                Applied
              </button>
            </>
          ) : (
            <>
              <button
                style={{
                  fontFamily: 'Segoe UI',               
                  color: "#5171ed",
                  padding: "8px 14px",
                  borderRadius: "8px",
                  border: "10px",
                  border: "1px solid #96a5e2",
                  fontSize: "12px",
                  fontWeight: 700,
                  cursor: "pointer",
                  transition: "0.2s ease",
                  backgroundColor:"#fff"
                }}
                onClick={handleClickApply}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = "#f6f7bc")
                }
                onMouseOut={(e) => (e.target.style.backgroundColor = "#fff")}
              >
                Apply Now
              </button>
            </>
          )}
        </div>
      </div>
      <Drawer
          title= {<div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              justifyContent: "space-between",
              marginLeft: "10px",
            }}
          >
            <span>{"Job Details - " + selectedJD?.QhCompanyJID}</span>
            <img
              src={logo}
              alt="logo"
              style={{
                height: "44px",
                borderRadius: "4px",
              }}
            />
          </div>}
          placement="right"
          width={700}
          onClose={() => setOpenDrawer(false)}
          open={openDrawer}
      >
        {selectedJD && (
          <NuJobsViewJob
            isDrawer={true}
            jdid={selectedJD?.QhCompanyJID}
            appliedJobs={appliedJobs}
            setAppliedJobs={setAppliedJobs}
            openJd={openJd}
            idx = {idx}
            loggedIn = {loggedIn}
            handleViewJob={() => {
                            addPendingSync(
                            "viewed",
                            openJd.QhOID,
                            openJd.QhCompanyJID
                        );
            }}            
          />
        )}
      </Drawer>    
    </div>
  );
}
